import $ from "jquery";

export class ModalVideo {
    private _element: JQuery;

    constructor(element: JQuery) {
        this._element = element;

        this._element.find(".btn-video").on("click", (e) => {
            e.preventDefault();

            const button = $(e.currentTarget);

            const url = button.attr("href");
            const html = this.markupPopup(url);
            $("body").append(html);

            $("#mdlVideoPopup").show();

            (async () => {
                await this.delay(250);
                $("#mdlVideoPopup").addClass("show");
            })();

            $("#mdlVideoPopup").on("hidden.bs.modal", function () {
                $("#mdlVideoPopup").remove();
            });
        });

        $(document).on("click", ".md-btn-close, .modal-video", function (e) {
            e.preventDefault();

            (async () => {
                $("#mdlVideoPopup").removeClass("show");
                await new Promise((resolve) => setTimeout(resolve, 250));
                $("#mdlVideoPopup").remove();
            })();
        });
    }

    private markupPopup = (videoUrl: string) => {
        return `
        <div id="mdlVideoPopup" class="v-modal modal-video fade" tabindex="-1" role="dialog" aria-hidden="true" data-index="" data-list="">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button class='modal-video__button modal-video__button--next'></button>
                    <div class="modal-body p-0">
                        <button type="button" class="md-btn-close" data-dismiss="modal">Zavřít</button>
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe src='${videoUrl}' class="embed-responsive-item"
                                allowfullscreen="allowfullscreen"
                                mozallowfullscreen="mozallowfullscreen" 
                                msallowfullscreen="msallowfullscreen" 
                                oallowfullscreen="oallowfullscreen" 
                                webkitallowfullscreen="webkitallowfullscreen"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>
                    <button class='modal-video__button modal-video__button--prev'></button>
                </div>
            </div>
            <div class="modal-backdrop fade show"></div>
        </div>`;
    };

    private delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    public static init() {
        const element = $(".video-cards");
        if (element.length) {
            new ModalVideo(element);
        }
    }
}
